import "core-js/modules/es.array.push.js";
import appHead from "./home_head.vue";
import appbottom from "./home_bottom.vue";
import showproduct from "./home_show.vue";
import productindex from "./home_product.vue";
import blankBottom from "@/components/base/blankBottom.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
import selectMode from "./select_button.vue";
import appWidget from "@/components/widget/index.vue";
import test_modal from "@/components/tools/test_modal.vue";
import picture_compare from "@/components/tools/picture_compare.vue";
import picture_compare_carousel from "@/components/tools/picture_compare_carousel.vue";
import CrooperImg from "@/components/tools/cropperImg.vue";
import image_generateall from "@/Painting/imagegenerate/image_generateall.vue";
import image_show from "./home_imageshow.vue";

//额外附加的数据(后台计算需要这些数据，前端并没使用)
const attachData = {
  scalewidth: 50,
  scaleheight: 50,
  width_chunk: 10,
  height_chunk: 10,
  imgcropbox: {
    left: 0,
    top: 0,
    width: 100,
    height: 100
  }
};
export default {
  name: "Upload",
  components: {
    appHead,
    showproduct,
    productindex,
    blankBottom,
    selectMode,
    appWidget,
    picture_compare,
    picture_compare_carousel,
    CrooperImg,
    image_generateall,
    appbottom,
    image_show
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'Home'; // 假设 'Home' 是主页路由名称
    }
  },

  data() {
    return {
      // uploading: false,
      // showDetails: false,
      // uploadUrl: "/sunbiliang/doubleface_upload", //上传图片的接口
      // createButImg: require("@/assets/doubleFaced/createBut.png"), //创建生成按钮
      imageTransButImg: getLocalImagePath('home_imagetrans_button'),
      //开始拼装按钮
      premodelsButtonImg: getLocalImagePath('home_premodels_button'),
      //预置模型按钮
      selectboxImg: require('@/assets/painting/first_button_bk.jpg'),
      //选择框背景图片

      // imageTransBackgroud : require('@/assets/fusebeads/first_picture_bk.jpg'),
      // premodelsBackgroud : require('@/assets/fusebeads/first_premodel_bk.jpg'),
      logotitle: require('@/assets/amalia-title.png'),
      // particelImg: require("@/assets/doubleFaced/particle.png"), //颗粒图
      // shopUrl: "https://www.amazon.com/dp/B0CDLJRPNT", //商店地址
      shopUrl: "https://www.amazon.co.uk/gp/product/B09JVKX8NZ?th=1",
      widthheight_ratio: 1
    };
  },
  mounted() {
    // const imageTrans = document.querySelector('.image_trans');
    // const parentElement = imageTrans.parentNode;
  },
  methods: {
    //点击使用指南
    handleGuide() {
      this.$router.push({
        path: 'guide'
      });
    },
    //点击图片转换页面
    gotoImageTrans() {
      this.$router.push({
        path: "imagetransfer"
      });
      //保存拼装记录
      // if (localStorage) {
      //   this.buildRecordData = localStorage.setItem("buildRecordData",modelUrl);
      // }
    },

    gotoPreModels() {
      // this.$router.push({ path: "premodels" });
      // 测试弹窗
      // this.$router.push({ path: "test_modal" });
      this.$router.push({
        path: "test_camera"
      });
    },
    //裁剪完成
    onCropOk(result) {
      this.$refs.bottomImageGenerateAll.onCropOk(result);
    },
    onCropCancel() {
      this.$refs.bottomImageGenerateAll.onCropCancel();
    },
    //开始裁剪
    startcrop(imgurl) {
      this.$refs.cutImg.onStartCrop(imgurl);
    },
    // 图片全部加载完毕
    onImagesLoadEnd() {
      this.$refs.bottomImageGenerateAll.showImageGenerateAll = true;
    }
  }
};